module.exports = __webpack_public_path__ + "static/media/Entrecomp-image.d378507d.jpg";